var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4.693 6.929c0-.931.299-1.875.897-2.831.598-.956 1.471-1.748 2.618-2.375 1.146-.627 2.485-.941 4.014-.941 1.421 0 2.677.262 3.765.787s1.928 1.238 2.521 2.14c.592.902.889 1.882.889 2.94 0 .833-.168 1.564-.506 2.191-.34.628-.74 1.169-1.207 1.625-.465.456-1.301 1.223-2.506 2.301-.334.303-.602.571-.803.801s-.35.441-.447.632c-.1.191-.174.383-.229.574-.055.19-.135.526-.242 1.007-.187 1.02-.77 1.529-1.75 1.529-.51 0-.939-.166-1.287-.5-.348-.333-.522-.828-.522-1.485 0-.823.127-1.536.382-2.14.254-.602.593-1.132 1.014-1.587.421-.456.99-.998 1.706-1.625.628-.549 1.081-.963 1.36-1.242.279-.28.514-.591.705-.934.191-.343.287-.715.287-1.117 0-.784-.291-1.446-.875-1.985-.584-.539-1.336-.809-2.257-.809-1.079 0-1.873.272-2.382.816-.508.544-.94 1.345-1.293 2.404-.333 1.108-.965 1.662-1.897 1.662-.549 0-1.012-.193-1.389-.581-.377-.387-.566-.807-.566-1.257zm7.176 16.115c-.598 0-1.12-.193-1.566-.58-.446-.388-.669-.929-.669-1.625 0-.618.215-1.138.647-1.559.431-.422.96-.633 1.588-.633.618 0 1.137.211 1.559.633.42.421.631.94.631 1.559 0 .686-.219 1.226-.66 1.617-.442.392-.952.588-1.53.588z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2793DB",
    strokeMiterlimit: 10,
    d: "M21.971 15.657h-3.788V11.87c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v3.787h-3.787c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h3.787v3.788c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25v-3.788h3.788c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddQuestion);
export default __webpack_public_path__ + "static/media/addQuestion.3a90d206449308e06f5e19820430484b.svg";
export { ForwardRef as ReactComponent };